export const pageMode = {
  data: function () {
    return {
      // *possible Modes: 
      // 'managers'
      // 'suppliers'
      pageMode: typeof window.pageMode !== 'undefined' ? window.pageMode : 'managers'
    }
  },
};
